import { Component, Inject, NgModule } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
@Component({
  selector: 'app-confirm-model',
  templateUrl: './confirm-model.component.html',
  styleUrls: ['./confirm-model.component.css']
})
export class ConfirmModelComponent  {
  chkDelKv: any;
  isChecked: any;
  constructor(public dialogRef: MatDialogRef<ConfirmModelComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.chkDelKv = localStorage.getItem("delKV");
    if (this.chkDelKv == "true") {
      this.isChecked = true;
    }
    else {
      this.isChecked = false;

    }
  }

  KvSelection(value): void {
    if (value == true) {
      localStorage.setItem("delKV", "false");
    }
    else {
      localStorage.setItem("delKV", "true");
    }
    
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  intendedAction() {
    this.dialogRef.close(true);
  }

}
